<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  items: { type: Array, default: () => [] },
  menuId: { type: String, required: true },
  selected: { type: String, default: '' },
});

const emit = defineEmits(['select']);
const { t } = useI18n();
</script>

<template>
  <ul
    class="list-none flex flex-col items-start gap-2 whitespace-nowrap py-2 pl-[37px]"
  >
    <li v-for="item in items" :key="item.value || 'default'">
      <button
        :data-testid="`broker-desktop-nav-${menuId}-${item.value || 'vgv'}`"
        class="h-14 w-full rounded-[10px] px-[22px] py-1 text-left text-base font-bold transition hover:bg-lais-bg-soft"
        :class="
          selected === item.value
            ? 'bg-[#EDF8F7] text-[#01988C]'
            : 'text-lais-text-body'
        "
        type="button"
        :aria-pressed="selected === item.value"
        @click="emit('select', item.value)"
      >
        {{ t('REAL_ESTATE_BROKER_DASHBOARD.DESKTOP_NAV.ITEM_COUNT', item) }}
      </button>
    </li>
  </ul>
</template>
